import React from 'react';
import '../css/popup.css';

const Modal = ({ isOpen, title, message, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="divCloseButton">
          <button onClick={onClose} className="CloseButton text">X</button>
        </div>
        <h3 className="titolo popupTitle">{title}</h3>
        {message && <p className="text">{message}</p>}
        {children}
      </div>
    </div>
  );
};

export default Modal;
